import { Button } from 'components/Button';
import { Spinner } from 'components/Shared/Loader';
import Markdown from 'components/Shared/Markdown';
import { useDidMount } from 'hooks';
import { PolicyInformation } from 'models/PolicyInformation';
import { useState } from 'react';
import { getSalePolicy } from 'services/ApiCheckoutPageService';
import { rm } from 'utils';
import styles from './salesPolicyModal.scss';

interface Props {
  onClose: () => void;
}

const SalesPolicyModal = ({ onClose }: Props) => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState<PolicyInformation>();

  useDidMount(() => {
    getSalePolicy()
      .then((policys: PolicyInformation[]) => {
        setPolicy(policys[0]);
      })
      .catch(() => {
        setPolicy({
          title: rm('dialogpopup_defaulttitle'),
          component: { tag: 'span', content: rm('error_generic_short') }
        });
      })
      .finally(() => setLoading(false));
  });

  return (
    <Spinner loading={loading} className={styles.spinner}>
      <Policy policy={policy} />
      <Button onClick={onClose} appearance="whitePill">
        {rm('shared_button_close')}
      </Button>
    </Spinner>
  );
};

interface Policy {
  policy?: PolicyInformation;
}
const Policy = ({ policy }: Policy): JSX.Element | null => {
  if (!policy) return null;

  return (
    <>
      <h2 className={styles.policyTitle}>{rm('checkout_our_terms')}</h2>
      <div className={styles.content}>
        <Markdown {...policy.component} />
      </div>
    </>
  );
};

export default SalesPolicyModal;
